import React from "react";

import duoDizzy from "../images/duo-dizzy.svg";
import styles from "../styles/UnrecoverableErrorPage.module.scss";

import TopBar from "./TopBar";

const UnrecoverableErrorPage = () => (
  <div>
    <TopBar />
    <div className={styles["error-container"]}>
      <div className={styles["error-illustration"]}>
        <img alt="duo dizzy" src={duoDizzy} />
      </div>
      <div className={styles["error-text"]}>
        Uh oh! It looks like we’re having some trouble displaying your learning
        challenge. Please post in{" "}
        <a
          href="https://duolingo.slack.com/archives/CSQLHL05V"
          rel="noreferrer"
          target="_blank"
        >
          #learning-challenge
        </a>{" "}
        on Slack to get help!
      </div>
    </div>
  </div>
);

export default UnrecoverableErrorPage;
